import React, { useState } from 'react';
import { IconButton, Popover, makeStyles } from '@material-ui/core';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { i18n } from '../../translate/i18n';
import { APP_FONT_FAMILY } from '../../styles/typography';
import SupportHelpPanel from '../SupportHelpPanel';

const useStyles = makeStyles(() => ({
  // Portal herda a fonte do body; o app usa outra.
  paper: {
    borderRadius: 16,
    width: 268,
    padding: '14px 12px 12px',
    boxShadow: '0 8px 28px rgba(0,0,0,0.13)',
    fontFamily: APP_FONT_FAMILY,
  },
}));

/**
 * Ícone de ajuda (?) da barra superior: abre o menu com o WhatsApp do suporte
 * e a base de conhecimento. `buttonClassName` dá ao ícone o visual dos outros
 * botões redondos da barra.
 */
export default function TopBarHelpMenu({ phone, knowledgeBaseUrl, buttonClassName }) {
  const classes = useStyles();
  const [anchor, setAnchor] = useState(null);
  const close = () => setAnchor(null);

  return (
    <>
      <IconButton
        className={buttonClassName}
        onClick={(e) => setAnchor(e.currentTarget)}
        title={i18n.t('helpMenu.button')}
        aria-label={i18n.t('helpMenu.button')}
        aria-haspopup="dialog"
      >
        <HelpOutlineIcon />
      </IconButton>
      <Popover
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={close}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{ className: classes.paper }}
      >
        <SupportHelpPanel phone={phone} knowledgeBaseUrl={knowledgeBaseUrl} onItemClick={close} />
      </Popover>
    </>
  );
}
